module.exports = __webpack_public_path__ + "static/img/des.c8cf36e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/buycardgetcoupon/des.png
// module id = BBYA
// module chunks = 0